export default __webpack_public_path__ + "static/media/Holy Atlantean Relic.8f501bbe.jpg";